var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('legend', [_vm._v("Upload Scan POD Sheet")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm2('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentType')
    },
    attrs: {
      "name": "shipmentType",
      "id": "shipmentType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shipmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setFileType]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.shipmentTypeList), function(shipmentType_obj) {
    return _c('option', {
      domProps: {
        "value": shipmentType_obj.businessconfig
      }
    }, [_vm._v(_vm._s(shipmentType_obj.businessconfig))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.shipmentType')),
      expression: "errors.has('form-2.shipmentType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select shipmentType")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubname),
      expression: "hubname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HubName')
    },
    attrs: {
      "name": "hubname",
      "id": "hubname",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.hubServiceCenterList), function(hub_obj) {
    return _c('option', {
      domProps: {
        "value": hub_obj.HubID
      }
    }, [_vm._v(_vm._s(hub_obj.HubName) + "-(" + _vm._s(hub_obj.HubID) + ")")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.hubname')),
      expression: "errors.has('form-2.hubname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Hub")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateobj.toDate),
      expression: "dateobj.toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "required": ""
    },
    domProps: {
      "value": (_vm.dateobj.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dateobj, "toDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.toDate')),
      expression: "errors.has('form-2.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Date")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileType),
      expression: "fileType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HubName')
    },
    attrs: {
      "name": "fileType",
      "id": "fileType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fileType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.fileTypeArray), function(file) {
    return _c('option', {
      domProps: {
        "value": file
      }
    }, [_vm._v(_vm._s(file))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.fileType')),
      expression: "errors.has('form-2.fileType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select File Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.users,
      "selected-option": _vm.userObj,
      "name": "userID",
      "placeholder": "Select user"
    },
    on: {
      "select": _vm.getdeliveyList
    },
    model: {
      value: (_vm.userID),
      callback: function($$v) {
        _vm.userID = $$v
      },
      expression: "userID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.userID')),
      expression: "errors.has('form-2.userID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select User ID")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.SearchLoading
    },
    on: {
      "update:active": function($event) {
        _vm.SearchLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": _vm.clearAll
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    on: {
      "click": _vm.clearAll
    }
  }), _vm._v(" Reset ")])], 1)], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.searchFlag) ? _c('div', {
    staticClass: "card-headerfrm"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select Batch :")]), _vm._v(" "), _vm._l((_vm.BatchArray), function(batch) {
    return [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.AssignBatchVal),
        expression: "AssignBatchVal"
      }],
      attrs: {
        "type": "radio",
        "id": batch.AssignBatchNo,
        "name": "AssignBatch"
      },
      domProps: {
        "value": batch.AssignBatchNo,
        "checked": _vm._q(_vm.AssignBatchVal, batch.AssignBatchNo)
      },
      on: {
        "change": function($event) {
          _vm.AssignBatchVal = batch.AssignBatchNo
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(batch.AssignBatchNo))])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AttachmentPageNo),
      expression: "AttachmentPageNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AttachmentPageNo')
    },
    attrs: {
      "name": "AttachmentPageNo",
      "id": "AttachmentPageNo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.AttachmentPageNo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Page No--")]), _vm._v(" "), _vm._l((100), function(page) {
    return _c('option', {
      domProps: {
        "value": page
      }
    }, [_vm._v(" Page - " + _vm._s(page))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    ref: "uploadfile",
    attrs: {
      "type": "file",
      "name": "uploadfile",
      "id": "uploadfile",
      "accept": ".png, .jpg, .jpeg, .gif, .bmp"
    },
    on: {
      "change": function($event) {
        return _vm.onuploadChange($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.uploadfile')),
      expression: "errors.has('form-1.uploadfile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please select file ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary upload-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.captureImage
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" Capture Image ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary upload-button",
    attrs: {
      "type": "button",
      "disabled": _vm.AttachmentPageNo == ''
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" Upload ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger upload-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeFile
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Remove ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.uploadLoader,
      "text": "Please wait pod upload is being processing.!"
    },
    on: {
      "update:active": function($event) {
        _vm.uploadLoader = $event
      }
    }
  })], 1)])])]) : _vm._e()]), _vm._v(" "), (_vm.NoBatchFlag) ? _c('div', {
    staticClass: "card-headerfrm"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [(_vm.isCapture) ? _c('button', {
    attrs: {
      "id": "snap"
    },
    on: {
      "click": _vm.capture
    }
  }, [_vm._v("Snap Photo")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVideo == true),
      expression: "isVideo == true"
    }],
    ref: "video",
    attrs: {
      "id": "video",
      "width": "340",
      "height": "280",
      "autoplay": ""
    }
  })]), _vm._v(" "), (_vm.isCapture) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('canvas', {
    ref: "canvas",
    staticStyle: {
      "margin-left": "100px",
      "width": "360",
      "height": "250px",
      "margin-top": "14px"
    },
    attrs: {
      "id": "canvas",
      "width": "340",
      "height": "280"
    }
  })]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Shipment Type :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Hub :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Delivery Date :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("File Type :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("User ID :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Attachment No. :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("No Batches Available..")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36215ca2","hasScoped":true}!./src/views/components/ScanPODSheet/UploadScanPODSheet/UploadScanPODSheet.component.html
// module id = 1153
// module chunks = 1